import { apiRequest } from './apiClient';

export async function getHelloMessage() {
  return apiRequest('/api/hello');
}

export async function getProducts() {
  return apiRequest('/api/stripe/products');
}

export async function getProductsWithPrices() {
  return apiRequest('/api/stripe/productsWithPrices');
}

export async function getProductsByTypeWithPrices() {
  return apiRequest('/api/stripe/productsByTypeWithPrices');
}

export async function requestInvoiceByMail(body) {
  return apiRequest('/api/stripe/request-invoice', {
    method: "POST",
    body: body,
  });
}

export async function calculateTax(body) {
  return apiRequest('/api/stripe/calculate-tax', {
    method: "POST",
    body: body,
  });
}

export async function upsertOrderData(body) {
  return apiRequest("/api/salesforce/upsert-order-data", {
    method: "POST",
    body: body,
  });
}

export async function getActivationData(body) {
  return apiRequest("/api/activation", {
    method: "POST",
    body: body,
  });
}

export async function validateVatNumber(vatNumber) {
  if (!vatNumber) {
    throw new Error("VAT number is required");
  }

  // VIES is often briefly overloaded, so retry a couple of times before surfacing the error
  const maxRetries = 4;
  const retryDelayMs = 2000;

  for (let attempt = 0; ; attempt++) {
    try {
      return await apiRequest(`/api/vies/${encodeURIComponent(vatNumber)}`, {
        method: "GET",
      });
    } catch (err) {
      if (attempt >= maxRetries) {
        throw err;
      }
      await new Promise(resolve => setTimeout(resolve, retryDelayMs));
    }
  }
}

// export async function setCaseStatus(body) {
//   return apiRequest("/api/salesforce/set-order-case-status", {
//     method: "POST",
//     body: body,
//   });
// }